import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaReportCard = Loadable({
  loader: () => import("./ReportCard"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default WeaReportCard;



// WEBPACK FOOTER //
// ./ecology9/wea-report-card/index.js